import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Error detail formatter for FastAPI responses
export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || 'Something went wrong';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map(e => (e?.msg || JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail?.message) return detail.message;
  if (detail?.msg) return detail.msg;
  if (typeof detail === 'object') return JSON.stringify(detail);
  return String(detail);
}

export default api;
